module.exports = __webpack_public_path__ + "img/Layer 1.81fde077.png";